"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scaleToFit = scaleToFit;
exports.isShutterstock = isShutterstock;
exports.isEditableImage = isEditableImage;

var _immutable = _interopRequireDefault(require("immutable"));

var EDITABLE_EXTENSIONS = _immutable.default.Set(['jpg', 'jpeg', 'png', 'gif', 'webp']);

function scaleToFit(file, size) {
  if (!file.get('width') || !file.get('height')) {
    return {
      width: size,
      height: null
    };
  }

  var width = file.get('width');
  var height = file.get('height');
  var scale = Math.min(1, size / Math.max(width, height));
  return {
    width: Math.min(size, Math.floor(width * scale)),
    height: Math.min(size, Math.floor(height * scale))
  };
}

function isShutterstock(file) {
  return file.hasIn(['meta', 'shutterstock_id']);
}

function isEditableImage(file) {
  return EDITABLE_EXTENSIONS.includes(file.get('extension')) && !isShutterstock(file);
}